<template>
  <div>
    <v-btn class="mt-4" @click.native="printOverallLiability">
        <v-icon>print</v-icon>
      </v-btn>
      <v-switch
          v-model="hideZero"
          inset
          class="mb-2"
          label="Major Expenses"
        />
        <v-spacer/>
    <v-data-table :items="getStaffAccount" class="elevation" :headers="headers">
      <template slot="items" slot-scope="props">
        <!-- <td>{{ props.item[".key"] }}</td> -->
        <td>{{ props.item.staffName }}</td>
        <td>{{ props.item.staffRole }}</td>
        <td>{{ firmbyId(props.item.firm) }}</td>
        <td>{{ props.item.creditTotal | amount }}</td>
        <td>{{ props.item.debitTotal | amount }}</td>
        <td>{{ (props.item.creditTotal - props.item.debitTotal) | amount }}</td>

        <td>
          <v-btn
            class="primary white--text"
            @click="openLiabilityDialog(props.item)"
          >
            View
          </v-btn>
        </td>
      </template>
      <template slot="no-data"> No Staff to Show </template>
    </v-data-table>

    <v-dialog v-model="dialog" transition="dialog-bottom-transition">
      <v-toolbar card dark color="primary">
        <v-toolbar-title>{{ selectedStaffName }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click.native="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table
        :items="selectedLiabilityList"
        class="elevation"
        :headers="liabilityListHeaders"
      >
        <template slot="items" slot-scope="props">
          <!-- <td>{{ props.item.isOpening ? "" : props.item[".key"] }}</td> -->
          <td>{{ props.item.isOpening ? "" : new Date(props.item.date).toLocaleDateString("en-GB") }}</td>
          <td>{{ props.item.isOpening ? "" : getFirmName(props.item.firm) }}</td>
          <td>{{ props.item.transactionType }}</td>

          <template v-if="props.item.isCredited">
            <td>
              <h3 class="success--text text--darken-4">
                {{ props.item.amount | amount }}
              </h3>
            </td>
            <td></td>
          </template>

          <template v-if="!props.item.isCredited">
            <td></td>
            <td>
              <h3 class="error--text text--darken-4">
                {{ props.item.amount | amount }}
              </h3>
            </td>
          </template>
          <td>{{props.item.isOpening ? "" : props.item.paymentType }}</td>
          <td>
            <v-btn
              icon
              class="primary--text"
              v-if="props.item.invoiceIdCash || props.item.invoiceIdBank"
              @click="openAssetInvoiceEdit(props.item)"
            >
              <v-icon dark> edit </v-icon>
            </v-btn>
          </td>
          <td>
            <v-btn
              icon
              class="primary--text"
              v-if="props.item.invoiceIdCash || props.item.invoiceIdBank"
              @click="deleteLiability(props.item)"
            >
              <v-icon dark> delete </v-icon>
            </v-btn>
          </td>
        </template>
        <template slot="no-data"> no record found </template>
      </v-data-table>
    </v-dialog>
    <!-- End of Edit Asset -->

    <!-- Start of Asset Invoice Edit -->
    <v-dialog
      v-model="dialogEditInvoice"
      persistent
      transition="dialog-bottom-transition"
    >
      <v-toolbar card dark color="primary">
        <v-toolbar-title>Edit Liability</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click.native="dialogEditInvoice = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card tile>
        <v-card-text>
          <v-menu
            :close-on-content-click="false"
            v-model="assetdatepicker"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="liabilityInvoiceDate"
              label="Date"
              prepend-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker
              v-model="liabilityInvoiceDate"
              @input="assetdatepicker = false"
            />
          </v-menu>
          <v-select
            v-model="selectedFirmFromAsset"
            :items="firmsByBrand"
            label="Select Firm"
            required
          >
            <template slot="selection" slot-scope="data">
              {{ data.item.text }}
            </template>
            <template slot="item" slot-scope="data">
              <v-list-tile-content>
                <v-list-tile-title
                  v-html="
                    `${data.item.firm.name}${
                      data.item.firm.proprietor
                        ? ' | ' + data.item.firm.proprietor
                        : ''
                    } | ₹: ${(data.item.firm.amount || 0).toLocaleString()}`
                  "
                />
              </v-list-tile-content>
            </template>
          </v-select>
          <v-select
            :items="staffByBrand"
            v-model="selectStaff"
            label="Select Staff Account"
          >
          </v-select>

          <!-- Addition or deletion on asset if old -->
          <v-select
            v-if="selectedFirmFromAsset && selectStaff"
            v-model="addition"
            label="Select transaction type"
            :items="getTransactionTypeOptions"
          />
          <v-text-field
            v-if="selectedFirmFromAsset && selectStaff && addition"
            type="number"
            label="Amount"
            v-model="additionAmount"
          />

          <!-- asset payement type -->
          <v-select
            dense
            v-if="additionAmount"
            label="Select Transaction Payment Type"
            v-model="operationPaymentType"
            :items="paymentOptions"
          />
          <!-- if cash&bank: ask for both value for seperate deduction -->
          <v-text-field
            v-if="operationPaymentType === 'CashAndBank Account'"
            v-model="operationAmountFromCash"
            type="number"
            label="Transactionn Amount to Pay From Cash"
            :error-messages="
              Number(operationAmountFromCash) +
                Number(operationAmountFromBank) !=
                Number(additionAmount) &&
              operationPaymentType == 'CashAndBank Account'
                ? [
                    'Sum of Cash amount and bank amount should be equal to Asset Amount',
                  ]
                : []
            "
          />
          <v-text-field
            v-if="operationPaymentType === 'CashAndBank Account'"
            v-model="operationAmountFromBank"
            type="number"
            label="Transactionn Amount to Pay From Bank"
            :error-messages="
              Number(operationAmountFromCash) +
                Number(operationAmountFromBank) !=
                Number(additionAmount) &&
              operationPaymentType == 'CashAndBank Account'
                ? [
                    'Sum of Cash amount and bank amount should be equal to Asset Amount',
                  ]
                : []
            "
          />
          <v-select
            v-if="operationPaymentType && operationPaymentType !== 'Cash'"
            v-model="operationAccountForTransaction"
            :items="otherAccountByBrand"
            label="Bank Account to Pay operation amount from Bank"
            required
          >
            <template slot="selection" slot-scope="data">
              {{ data.item.text }}
            </template>
            <template slot="item" slot-scope="data">
              <v-list-tile-content>
                <v-list-tile-title
                  v-html="
                    `${data.item.text}
                            ${
                              data.item.account.bankName
                                ? ' | ' + data.item.account.bankName
                                : ''
                            }
                            ${
                              data.item.account.accountType
                                ? ' | ' + data.item.account.accountType
                                : ''
                            }
                            | ₹: ${(
                              data.item.account.amount || 0
                            ).toLocaleString()}`
                  "
                />
              </v-list-tile-content>
            </template>
          </v-select>

          <!-- add asset remark for  invoice/asset add-->
          <v-text-field
            v-if="additionAmount && operationPaymentType"
            label="Remark"
            v-model="staffRemark"
          >
          </v-text-field>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="liabilityAmountClick">
              <v-icon right dark>money_off</v-icon>Save
            </v-btn>
            <v-btn color="primary" @click="dialogEditInvoice = false">
              <v-icon left dark>cancel</v-icon>Cancel
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
import _ from "lodash";
import { liabilityOverallReport } from "../../../utils/pdf-reports/liabilityOverallReport.js";

const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];

export default {
  name: "liabilityTableInfo",
  props: {
    accountsByBrand: { type: Array },
    firmsByBrand: { type: Array },
    staffAccount: { type: Array },
    paymentOptions: { type: Array },
  },
  created() {
    this.$bindAsArray(
      "liabilitys",
      this.$root.$firebaseRefs.liabilitys
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "firms",
      this.$root.$firebaseRefs.firm
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "staff",
      this.$root.$firebaseRefs.staff
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsObject(
      "firmById",
      this.$root.$firebaseRefs.firm
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsObject(
      "bankById",
      this.$root.$firebaseRefs.account
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsObject(
      "staffById",
      this.$root.$firebaseRefs.staff
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand", "finYear"]),
    getStaffAccount() {
      if (this.selectedBrand) {
        const staffList = this.staff.filter(
          (item) => item["brand"] === this.selectedBrand && item["firm"] != ""
        );

        const result = staffList.map((e) => {
          const liabilityList = _.filter(
            this.liabilitys,
            { staffId: e[".key"] },
            e.date >= this.finYear.start,
            e.date <= this.finYear.end
          );
          e.liabilityList = liabilityList;
          const debitTotal = _.sumBy(liabilityList, function (s) {
            if (!s.isCredited) return s.amount;
          });

          e.debitTotal = debitTotal ? debitTotal : 0;

          let creditTotal = _.sumBy(liabilityList, function (s) {
            if (s.isCredited) return s.amount;
          });
          if(e.openingBalance) {
            creditTotal += Number.parseFloat(e.openingBalance);
            e.liabilityList.push({
              "isCredited" : true,
              amount : e.openingBalance,
              isOpening : true,
              transactionType : "Opening Balance"
            })
          }
          
          e.creditTotal = creditTotal ? creditTotal : 0;
          return e;
        });

        return result;
      }
    },
    accountsByFirm() {
      if (this.selectedFirmFromAsset) {
        return this.accountsByBrand.filter(
          (item) => item.account.firm === this.selectedFirmFromAsset
        );
      }
      return [];
    },
    staffByBrand() {
      if (this.selectedFirmFromAsset) {
        return this.staffAccount.filter(
          (item) => item.staff.firm === this.selectedFirmFromAsset
        );
      }
      return [];
    },
    otherAccountByBrand() {
      return this.accountsByFirm.filter(
        (account) => account.account.accountType !== "Loan A/C"
      );
    },
    getTransactionTypeOptions() {
      return [
        { text: "liability", value: "liability" },
        { text: "Advance", value: "advance" },
        { text: "Commission", value: "commission" },
        { text: "Return", value: "return" },
      ];
    },
  },
  data() {
    return {
      dialog: false,
      selectedLiabilityList: [],
      selectedStaffName: "",
      asset: {},
      selectedAsset: [],
      selectedLiability: null,
      selectedCashInvoice: null,
      selectedBankInvoice: null,
      selectStaff: null,
      dialogEditInvoice: false,
      additionAmount: null,
      operationPaymentType: null,
      operationAmountFromCash: 0,
      operationAmountFromBank: 0,
      selectedFirmFromAsset: null,
      operationAccountForTransaction: null,
      staffRemark: null,
      addition: null,
      selectStaff: null,
      liabilityInvoiceDate: null,
      assetdatepicker: false,
      headers: [
        // { text: "Id", value: ".key", sortable: false },
        { text: "Name", value: "staffName", sortable: false },
        { text: "Role", value: "staffRole", sortable: false },
        { text: "Firm", value: "firm", sortable: false },
        { text: "Debit", value: "amount", sortable: false },
        { text: "Credit", value: "amount", sortable: false },
        { text: "Running Balance", value: "amount", sortable: false },
        { text: "Action", value: "paymentType", sortable: false },
      ],
      liabilityListHeaders: [
        // { text: "Id", value: ".key", sortable: false },
        { text: "Date", value: "date", sortable: true },
        { text: "Firm", value: "firm", sortable: true },
        { text: "Transaction type", value: "transactionType", sortable: false },
        { text: "Debit", value: "amount", sortable: false },
        { text: "Credit", value: "amount", sortable: false },
        { text: "Payment Type", value: "paymentType", sortable: false },
        { text: "Action", value: "paymentType", sortable: false },
      ],
    };
  },
  methods: {
    openLiabilityDialog(payload) {
      this.selectedLiabilityList = payload.liabilityList;
      this.selectedStaffName = payload.staffName + " |" + payload.staffRole;
      this.dialog = true;
    },
    async printOverallLiability(liability){
      let firm  =this.firms.filter(item => item['.key'] === liability['firm'])[0];
      await liabilityOverallReport({
        // school: this.schools.filter((item) => item.id == this.defaultSchool)[0],
        firm : this.firm,        
        list : this.getStaffAccount,
      }).then((doc) => {
        pdfMake.createPdf(doc).download('LIABILITY_REPORT_' + new Date ().toLocaleDateString('en-GB'));
      });
    },
    firmbyId(id) {
      return this.firms.filter((item) => item[".key"] == id)[0].name;
    },
    getFirmName(e) {
      let firm;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter((item) => item[".key"] === e)[0];
      }
      if (firm) return firm.name;
    },
    deleteLiability(liability) {
      if (confirm("Are you sure?")) {
        this.$root.$firebaseRefs.liabilitys.child(liability[".key"]).remove();
        this.$root.$firebaseRefs.invoice.child(liability.invoiceIdCash).remove();
        this.$root.$firebaseRefs.invoice.child(liability.invoiceIdBank).remove();
        this.dialogEditInvoice = false;
      }
    },
    openAssetInvoiceEdit(liability) {
      this.selectedLiability = liability;
      this.selectedCashInvoice = liability.invoiceIdCash;
      this.selectedBankInvoice = liability.invoiceIdBank;
      this.additionAmount = Number.parseFloat(liability.amount);
      this.operationAmountFromCash = Number.parseFloat(
        liability.amountFromCash || 0
      );
      this.operationAmountFromBank = Number.parseFloat(
        liability.amountFromBank || 0
      );
      this.operationAccountForTransaction = liability.bank;
      let today = new Date(liability.date);
      this.liabilityInvoiceDate = `${today.getFullYear()}-${
        today.getMonth() + 1
      }-${today.getDate()}`;
      this.selectedFirmFromAsset = liability.firm;
      this.selectStaff = liability.staffId;
      this.addition = liability.transactionType;
      this.additionAmount = Number.parseFloat(liability.amount || 0);
      this.operationPaymentType = liability.paymentType;
      this.staffRemark = liability.remark;

      this.dialogEditInvoice = true;
    },

    liabilityAmountClick: async function (e) {

         let additionAmount =
        Number.parseFloat(this.additionAmount) -
        Number.parseFloat(this.selectedLiability.amount);
        let operationAmountFromCash = Number.parseFloat(this.operationAmountFromCash) -
          Number.parseFloat(this.selectedLiability.amountFromCash);
        let operationAmountFromBank = Number.parseFloat(this.operationAmountFromBank) -
          Number.parseFloat(this.selectedLiability.amountFromBank);
      var self = this;

      const asset = {
        brand: this.selectedBrand,
      };

      if (!this.selectedFirmFromAsset) {
        return this.$emit("notify", "select firm");
      }

      if (!this.addition) {
        return this.$emit("notify", "Select transaction type");
      }

      if (!this.additionAmount) {
        return this.$emit("notify", "Add amount");
      } else {
        asset.totalAdditionAmount =
          (this.asset.totalAdditionAmount || 0) + Number(this.additionAmount);
      }

      if (
        this.operationPaymentType === "CashAndBank Account" &&
        (!this.operationAmountFromCash || !this.operationAmountFromBank)
      ) {
        return this.$emit(
          "notify",
          "Enter amount to pay from bank and cash for operation"
        );
      }
      if (
        this.operationPaymentType !== "Cash" &&
        !this.operationAccountForTransaction
      ) {
        return this.$emit("notify", "Select Bank account for operation");
      }

      let transactionError = false;
      if (this.addition != "return") {
        const firmBalance = this.firmById[this.selectedFirmFromAsset].amount;
        const accountBalance = this.operationAccountForTransaction
          ? this.bankById[this.operationAccountForTransaction].amount
          : 0;
         
        switch (this.operationPaymentType) {
          case "Cash":
              
            if (additionAmount > firmBalance) {
              transactionError = `Insufficiant balance in firm ${firmBalance}`;
              break;
            }
            break;
          case "Bank Account":
            if (additionAmount > accountBalance) {
              // Insufficient balance in bank account
              transactionError = `Insufficient balance in bank Account ${accountBalance} to pay`;
              break;
            }
            break;
          case "CashAndBank Account":
            if (
              Number(additionAmount) !==
              Number(operationAmountFromCash) +
                Number(operationAmountFromBank)
            ) {
              transactionError =
                "Total of by cash and bank amount should be same as operation Amount!";
              break;
            }
            if (operationAmountFromCash > firmBalance) {
              transactionError = `Insufficiant balance in firm ${firmBalance}`;
              break;
            }
            if (operationAmountFromBank > accountBalance) {
              // Insufficient balance in bank account
              transactionError = `Insufficient balance in bank Account ${accountBalance} to pay`;
              break;
            }
            break;
        }
      }
      if (transactionError) {
        return this.$emit("notify", transactionError);
      }

      // liability adance commostion debite
      let globStaffType = this.staffById[this.selectStaff].staffRole;

      let liabilityData = {
        brand: this.selectedBrand,
        firm: this.selectedFirmFromAsset,
        staffId: this.selectStaff,
        staffType: globStaffType,
        transactionType: this.addition, //liability etc
        paymentType: this.operationPaymentType,
        amount: Number(this.additionAmount),
        date: this.liabilityInvoiceDate
          ? Date.parse(this.liabilityInvoiceDate)
          : Date.now(),
        remark: this.staffRemark,
      };

      if (this.addition != "return") {
        liabilityData.isCredited = true;

        // create a invoice data now
        if (this.operationPaymentType == "Cash") {
          const invoiceCashData = {
            brand: this.selectedBrand,
            firm: this.selectedFirmFromAsset,
            type: "automatic invoice",
            transactionType: "Staff",
            paymentType: this.operationPaymentType,
            accountNumber: "",
            isCredited: false,
            totalAmount: Number(this.additionAmount),
            remark: this.staffRemark,
            staffkey: this.selectStaff,
            staffType: globStaffType,
            date: this.liabilityInvoiceDate
              ? Date.parse(this.liabilityInvoiceDate)
              : Date.now(),
          };

          var firm = this.firmById[invoiceCashData.firm];
          firm.amount = firm && firm.amount - additionAmount;
          this.$root.$firebaseRefs.firm.child(invoiceCashData.firm).set(firm);

          invoiceCashData.amountFromCash = invoiceCashData.totalAmount;
          invoiceCashData.liabilityType = this.addition;
          this.$root.$firebaseRefs.invoice
            .child(this.selectedCashInvoice)
            .set(invoiceCashData);
          //let res = self.$root.$firebaseRefs.invoice.push(invoiceCashData);
          liabilityData["invoiceIdCash"] = this.selectedCashInvoice;
          liabilityData["amountFromCash"] = invoiceCashData["totalAmount"];


        } else if (this.operationPaymentType == "Bank Account") {
          let invoiceViaAccount = {
            brand: this.selectedBrand,
            firm: this.selectedFirmFromAsset,
            type: "automatic invoice",
            transactionType: "Staff",
            paymentType: this.operationPaymentType,
            isCredited: false,
            totalAmount: Number(this.additionAmount),
            remark: this.staffRemark,
            staffkey: this.selectStaff,
            staffType: globStaffType,
            date: this.liabilityInvoiceDate
              ? Date.parse(this.liabilityInvoiceDate)
              : Date.now(),
          };

          invoiceViaAccount.amountFromBank = additionAmount;
          invoiceViaAccount.bank = this.operationAccountForTransaction;

          if (invoiceViaAccount.bank) {
            invoiceViaAccount.accountNumber =
              this.bankById[invoiceViaAccount.bank].accountnumber;
          }

          var firm = this.firmById[invoiceViaAccount.firm];
          var bank = this.bankById[invoiceViaAccount.bank];

          bank.amount = bank && bank.amount - invoiceViaAccount.totalAmount;
          this.$root.$firebaseRefs.account
            .child(invoiceViaAccount.bank)
            .set(bank);
          invoiceViaAccount.liabilityType = this.addition;
          // let res = self.$root.$firebaseRefs.invoice.push(invoiceViaAccount);
          this.$root.$firebaseRefs.invoice
            .child(this.selectedBankInvoice)
            .set(invoiceViaAccount);
          liabilityData["invoiceIdBank"] = this.selectedBankInvoice;
          liabilityData["amountFromBank"] = invoiceViaAccount["totalAmount"];
          liabilityData["bank"] = invoiceViaAccount["bank"];
          self.additionAmount = null;
          self.selectedFirmFromAsset = null;
          self.staffRemark = null;
        } else {
          // CASHwithBank Account

          let invoiceData = {
            brand: this.selectedBrand,
            firm: this.selectedFirmFromAsset,
            type: "automatic invoice",
            transactionType: "Staff",
            isCredited: false,
            remark: this.staffRemark,
            staffkey: this.selectStaff,
            staffType: globStaffType,
            date: this.liabilityInvoiceDate
              ? Date.parse(this.liabilityInvoiceDate)
              : Date.now(),
          };

          //CASH *************************************
          var firm = this.firmById[invoiceData.firm];

          const invoiceCash = { ...invoiceData };
          invoiceCash.paymentType = "CashAndBank Account";
          invoiceCash.totalAmount = Number(this.operationAmountFromCash);
          invoiceCash.amountFromCash = Number(this.operationAmountFromCash);

          firm.amount = firm && firm.amount - operationAmountFromCash;
          this.$root.$firebaseRefs.firm.child(invoiceCash.firm).set(firm);
          invoiceCash.liabilityType = this.addition;
          //let res = self.$root.$firebaseRefs.invoice.push(invoiceCash);
          liabilityData["invoiceIdCash"] = this.selectedCashInvoice;
          this.$root.$firebaseRefs.invoice
            .child(this.selectedCashInvoice)
            .set(invoiceCash);
          liabilityData["amountFromCash"] = invoiceCash["totalAmount"];
          // BANK **************************************
          const invoiceBank = { ...invoiceData };
          invoiceBank.paymentType = "Bank Account";
          invoiceBank.totalAmount = Number(this.operationAmountFromBank);
          invoiceBank.amountFromBank = Number(this.operationAmountFromBank);
          invoiceBank.bank = this.operationAccountForTransaction;

          if (invoiceBank.bank) {
            invoiceBank.accountNumber =
              this.bankById[invoiceBank.bank].accountnumber;
          }

          var bank = this.bankById[invoiceBank.bank];
          bank.amount = bank && bank.amount - operationAmountFromBank;
          this.$root.$firebaseRefs.account.child(invoiceBank.bank).set(bank);
          invoiceBank.liabilityType = this.addition;
          //res = self.$root.$firebaseRefs.invoice.push(invoiceBank);
          liabilityData["invoiceIdBank"] = this.selectedBankInvoice;
          this.$root.$firebaseRefs.invoice
            .child(this.selectedBankInvoice)
            .set(invoiceBank);
          liabilityData["amountFromBank"] = invoiceBank["totalAmount"];
          liabilityData["bank"] = invoiceBank["bank"];
          self.additionAmount = null;
          self.selectedFirmFromAsset = null;
          self.staffRemark = null;
        }
      } else {
        liabilityData.isCredited = false;

        if (this.operationPaymentType == "Cash") {
          const invoiceCashData = {
            brand: this.selectedBrand,
            firm: this.selectedFirmFromAsset,
            type: "automatic invoice",
            transactionType: "Staff",
            paymentType: this.operationPaymentType,
            accountNumber: "",
            isCredited: true,
            totalAmount: Number(this.additionAmount),
            remark: this.staffRemark,
            staffkey: this.selectStaff,
            staffType: globStaffType,
            date: this.liabilityInvoiceDate
              ? Date.parse(this.liabilityInvoiceDate)
              : Date.now(),
          };

          var firm = this.firmById[invoiceCashData.firm];
          firm.amount = firm && firm.amount + additionAmount;
          this.$root.$firebaseRefs.firm.child(invoiceCashData.firm).set(firm);

          invoiceCashData.amountFromCash = invoiceCashData.totalAmount;
          invoiceCashData.liabilityType = this.addition;
          //let res = self.$root.$firebaseRefs.invoice.push(invoiceCashData);
          this.$root.$firebaseRefs.invoice
            .child(this.selectedCashInvoice)
            .set(invoiceCashData);
          liabilityData["amountFromCash"] = invoiceCashData["totalAmount"];
          liabilityData["invoiceIdCash"] = this.selectedCashInvoice;
        } else if (this.operationPaymentType == "Bank Account") {
          let invoiceViaAccount = {
            brand: this.selectedBrand,
            firm: this.selectedFirmFromAsset,
            type: "automatic invoice",
            transactionType: "Staff",
            paymentType: this.operationPaymentType,
            isCredited: true,
            totalAmount: Number(this.additionAmount),
            remark: this.staffRemark,
            staffkey: this.selectStaff,
            staffType: globStaffType,
            date: this.liabilityInvoiceDate
              ? Date.parse(this.liabilityInvoiceDate)
              : Date.now(),
          };

          invoiceViaAccount.amountFromBank = invoiceViaAccount.totalAmount;
          invoiceViaAccount.bank = this.operationAccountForTransaction;

          if (invoiceViaAccount.bank) {
            invoiceViaAccount.accountNumber =
              this.bankById[invoiceViaAccount.bank].accountnumber;
          }

          var firm = this.firmById[invoiceViaAccount.firm];
          var bank = this.bankById[invoiceViaAccount.bank];

          bank.amount = bank && bank.amount + additionAmount;
          this.$root.$firebaseRefs.account
            .child(invoiceViaAccount.bank)
            .set(bank);
          invoiceViaAccount.liabilityType = this.addition;
          //let res = self.$root.$firebaseRefs.invoice.push(invoiceViaAccount);
          liabilityData["invoiceIdBank"] = this.selectedBankInvoice;
          this.$root.$firebaseRefs.invoice
            .child(this.selectedBankInvoice)
            .set(invoiceViaAccount);
          liabilityData["amountFromBank"] = invoiceViaAccount["totalAmount"];
          liabilityData["bank"] = invoiceViaAccount["bank"];
          self.additionAmount = null;
          self.selectedFirmFromAsset = null;
          self.staffRemark = null;
        } else {
          // CASHwithBank Account

          let invoiceData = {
            brand: this.selectedBrand,
            firm: this.selectedFirmFromAsset,
            type: "automatic invoice",
            transactionType: "Staff",
            isCredited: true,
            remark: this.staffRemark,
            staffkey: this.selectStaff,
            staffType: globStaffType,
            date: this.liabilityInvoiceDate
              ? Date.parse(this.liabilityInvoiceDate)
              : Date.now(),
          };

          //CASH *************************************
          var firm = this.firmById[invoiceData.firm];

          const invoiceCash = { ...invoiceData };
          invoiceCash.paymentType = "CashAndBank Account";
          invoiceCash.totalAmount = Number(this.operationAmountFromCash);
          invoiceCash.amountFromCash = Number(this.operationAmountFromCash);

          firm.amount = firm && firm.amount + operationAmountFromCash;
          this.$root.$firebaseRefs.firm.child(invoiceCash.firm).set(firm);
          invoiceCash.liabilityType = this.addition;
          //let res = self.$root.$firebaseRefs.invoice.push(invoiceCash);
          this.$root.$firebaseRefs.invoice
            .child(this.selectedCashInvoice)
            .set(invoiceCash);
          liabilityData["amountFromCash"] = invoiceCash["totalAmount"];
          liabilityData["invoiceIdCash"] = this.selectedCashInvoice;
          // BANK **************************************
          const invoiceBank = { ...invoiceData };
          invoiceBank.paymentType = "Bank Account";
          invoiceBank.totalAmount = Number(this.operationAmountFromBank);
          invoiceBank.amountFromBank = Number(this.operationAmountFromBank);
          invoiceBank.bank = this.operationAccountForTransaction;

          if (invoiceBank.bank) {
            invoiceBank.accountNumber =
              this.bankById[invoiceBank.bank].accountnumber;
          }

          var bank = this.bankById[invoiceBank.bank];
          bank.amount = bank && bank.amount + operationAmountFromBank;
          this.$root.$firebaseRefs.account.child(invoiceBank.bank).set(bank);
          invoiceBank.liabilityType = this.addition;
          //res = self.$root.$firebaseRefs.invoice.push(invoiceBank);
          liabilityData["invoiceIdBank"] = this.selectedBankInvoice;
          this.$root.$firebaseRefs.invoice
            .child(this.selectedBankInvoice)
            .set(invoiceBank);
          liabilityData["amountFromBank"] = invoiceBank["totalAmount"];
          liabilityData["bank"] = invoiceBank["bank"];
          self.additionAmount = null;
          self.selectedFirmFromAsset = null;
          self.staffRemark = null;
        }
      }

      this.$root.$firebaseRefs.liabilitys
        .child(this.selectedliability[".key"])
        .set(liabilityData);
      // close modal
      this.$emit("notify", "liability account edited", true);
      this.dialog = false;
      this.dialogEditInvoice = false;
      //this.reset(true);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/InvoiceManagement/table/liabilityTable.vue